import { Button, Stack } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { printHTMLData } from 'utils/printHTMLData';
import { extractTdContent } from './functions/extractTdContent';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const PatientsToVisitPreview = () => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop
  const location = useLocation();
  const data = location.state;
  const print_label = FindLangKey(
    'confer-summary-label-print-summary'
  );

  const extracted_data = extractTdContent(
    data.html_data.replace(/\/r|\/n/g, '')
  )?.filter((fl)=>fl.length>0);

 
  console.log(data.html_data.replace(/\/r|\/n/g, ''))

  return (
    <React.Fragment>
      <Button
        fullWidth
        variant="contained"
        sx={{
          color: `${themeColors.ColorPrimary} !important`,
          my: '1em',
          width: '97%',
          ml: '.5em',
        }}
        onClick={() => printHTMLData(data)}
      >
        {print_label}
      </Button>

      {screenWidth >= 1024 ? (
        <div className="iframe-container">
          <iframe
            srcDoc={data.html_data.replace(/\/r|\/n/g, '')}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title="Rendered HTML Content"
            className="patients-for-visit-iframe"
          />
        </div>
      ) : (
        <Stack gap='.5em' p='1em'>
          {extracted_data?.map((row,index)=>(
            <div key={index} style={{borderBottom:'1px solid black',paddingBlock:'0.5em'}}>{ArabicToPersian(row)}</div>
          ))

          }
        </Stack>
      )}
    </React.Fragment>
  );
};

export default PatientsToVisitPreview;
